var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.label)?_c('div',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm._f("toMoney")((_vm.value || 0))))])])
}
var staticRenderFns = []

export { render, staticRenderFns }